const getters = {
    token: state => state.user.token,
    data: state => state.user.data,
    screenshotList: state => state.common.screenshotList,
}
export default getters